// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zX_gdD2_xUiId3 {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 600px;
}
.NlWGwRNG5hPnTY {
  min-width: 640px;
  min-height: 283px;
}
@media only screen and (max-width: 600px) {
  .NlWGwRNG5hPnTY {
    min-width: 0;
  }
}
`, ""]);
// Exports
export var cardDetailLoading = `zX_gdD2_xUiId3`;
export var cardBackRedesign = `NlWGwRNG5hPnTY`;
export default ___CSS_LOADER_EXPORT___;
